/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { tableStateStatusEnumSchema } from "./tableStateStatusEnumSchema.ts";

export const tableStateSchema = z.object({
	id: z.uuid(),
	number: z.int(),
	name: z.string(),
	seating_capacity: z.int().describe("Мест за столом; 0 — вместимость не заполнена в iiko, а не «мест нет»"),
	status: tableStateStatusEnumSchema.describe("* `free` - Свободен\n* `occupied` - Занят заказом\n* `reserved` - Идёт бронь\n* `unknown` - Касса не ответила"),
	busy_until: z
		.string()
		.nullable()
		.describe("До какого времени идёт текущая бронь, местное время точки (2026-09-23T21:30:00) доступно только при статусе reserved"),
	next_reserve_at: z.string().nullable().describe("Начало ближайшей брони в следующие сутки, местное время точки (2026-09-23T20:00:00)"),
	is_banquet: z.boolean().describe("Текущая или ближайшая бронь — банкет"),
});
